(ns com.theplantscape.svg-generation.diagram)

(defn draw-layer [svg-plant2 data]
  (->> data
       (reduce (fn [v object] (conj v (svg-plant2 object))) [:g])))

(defn generate-diagram
  [defs layers]
  (reduce
   (fn diagram-layer [diagram [layer-type objects]]
     (if (empty? objects)
       diagram
       (conj diagram (draw-layer layer-type objects))))
   [:g#main-diagram
    (into [:defs] defs)]
   layers)

;[svg/boundary @diagram]
  #_[:rect {:x (* -1 (/ (js/parseInt (or (-> @diagram :diagram.settings/width) "100")) 2))
            :y (* -1 (/ (js/parseInt (or (-> @diagram :diagram.settings/height) "100")) 2))
            :width (str  (or (-> @diagram :diagram.settings/width) "100") "px")
            :height (str  (or (-> @diagram :diagram.settings/height) "100") "px")
            :style {:fill "#dcbffa"}}]
        ;(reduce (fn [v [svg-plant object]] (conj v (svg-plant object))) [:g] layers)
  )



